import Vue from 'vue'
import VueRouter from 'vue-router'
import Search from '../views/Search.vue'
import Item from '../views/Item.vue'
import Embed from '../views/Embed.vue'
import EmbedNoTitle from '../views/EmbedNoTitle.vue'
import Cover from '../views/Cover.vue'
import Datastories from '../views/Datastories.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Profile from '../views/Profile.vue'
import ActivateUser from '../views/ActivateUser.vue'
import InvalidUser from '../views/InvalidUser.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import ValidateUser from '../views/ValidateUser.vue'
import ValidUser from '../views/ValidUser.vue'
import ChangePassword from '../views/ChangePassword.vue'
import ConfirmPasswordChange from '../views/ConfirmPasswordChange.vue'
import DeleteUser from '../views/DeleteUser.vue'
import ConfirmUserDelete from '../views/ConfirmUserDelete.vue'
import About from '../views/About.vue'
import Quote from '../views/Quote.vue'
import LinksPage from '../views/LinksPage.vue'
// import Email from '../views/Email.vue'
import EmailSend from '../views/EmailSend.vue'
// import EmailCom from '../views/EmailCom.vue'
import HelpUsers from '../views/HelpUsers.vue'
import Report from '../views/Report.vue'
import PBD from '../components/webstats/PBD.vue'
import Page429 from '../components/Page429.vue'
import EmbedPBD from '../components/webstats/EmbedPBD.vue'
import store from '../store'

let storeInstance = store

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Cover',
    component: Cover,
  },
  {
    path: '/map-datastories',
    name: 'Datastories',
    component: Datastories,
  },
  {
    path: '/page-429',
    name: 'Page429',
    component: Page429,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
  },
  {
    path: '/perfil/:optype?/:params?',
    name: 'Profile',
    component: Profile,
    props: true,
  },
  {
    path: '/search/:params?',
    name: 'Search',
    component: Search,
    props: true,
  },
  {
    path: '/about',
    name: 'About',
    component: About,
  },
  {
    path: '/qui-som',
    name: 'Qui som',
    component: About,
  },
  {
    path: '/quienes-somos',
    name: 'Quiénes Somos',
    component: About,
  },
  {
    path: '/quote-and-use-license',
    name: 'Quote',
    component: Quote,
  },
  {
    path: '/links',
    name: 'LinksPage',
    component: LinksPage,
  },
  {
    path: '/invalid-user',
    name: 'Invalid',
    component: InvalidUser,
  },
  {
    path: '/forgot-password',
    name: 'Forgot',
    component: ForgotPassword,
  },
  {
    path: '/validate-user',
    name: 'Validate',
    component: ValidateUser,
  },
  {
    path: '/valid-user',
    name: 'Valid',
    component: ValidUser,
  },
  {
    path: '/change-password/:params?',
    name: 'ChangePw',
    component: ChangePassword,
    props: true,
  },
  {
    path: '/confirm-password-change',
    name: 'ConfirmPw',
    component: ConfirmPasswordChange,
  },
  {
    path: '/activate-user/:params?',
    name: 'Activate',
    component: ActivateUser,
    props: true,
  },
  {
    path: '/delete-user',
    name: 'Delete',
    component: DeleteUser,
  },
  {
    path: '/confirm-user-deleted',
    name: 'ConfirmDelete',
    component: ConfirmUserDelete,
  },
  {
    path: '/email-send',
    name: 'EmailSend',
    component: EmailSend,
  },
  // {
  //   path: '/email-com',
  //   name: 'EmailCom',
  //   component: EmailCom,
  // },
  // {
  //   path: '/email',
  //   name: 'Email',
  //   component: Email,
  // },
  {
    path: '/help-users/:params?',
    name: 'Help',
    component: HelpUsers,
    props: true,
  },
  {
    path: '/ayuda/:params?',
    name: 'Ayuda',
    component: HelpUsers,
    props: true,
  },
  {
    path: '/ajuda/:params?',
    name: 'Ajuda',
    component: HelpUsers,
    props: true,
  },
  {
    path: '/web-statistics/:params?/',
    name: 'WebStats',
    component: PBD,
    props: true,
  },
  {
    path: '/embed/web-statistics/:params?/',
    name: 'EmbedWebStats',
    component: EmbedPBD,
    props: true,
  },
  {
    path: '/help-users/:params?',
    name: 'Help',
    component: HelpUsers,
    props: true,
  },
  {
    path: '/embed/:type?/:cardId(.+)/',
    name: 'Embed',
    component: Embed,
    props: true,
  },
  {
    path: '/embed-no-title/:type?/:cardId(.+)/',
    name: 'EmbedNoTitle',
    component: EmbedNoTitle,
    props: true,
  },
  {
    path: '/report/:reportId?',
    name: 'Report',
    component: Report,
    props: true,
  },
  {
    path: '/:type?/:cardId(.+)/',
    name: 'Item',
    component: Item,
    props: true,
  },
]

let routesWithLang = routes.reduce((res, route) => {
  res.push({ ...route, path: '/:lang(ca|en|es)' + route.path })
  return res
}, [])

const router = new VueRouter({
  scrollBehavior(to) {
    if (to.query.view) {
      return null
    } else {
      return { y: 0 }
    }
  },
  routes: routesWithLang,
  mode: 'history',
  base: process.env.BASE_URL,
})

router.beforeEach((to, from, next) => {
  const { lang } = to.params
  const currentLang = from.params.lang || storeInstance.state.i18n.lang
  const redirectTo = to.hash
    ? lang
      ? to.path
      : `/${currentLang}${to.path}`
    : lang
    ? to.fullPath
    : `/${currentLang}${to.fullPath}`
  // const userLogViews = ['Profile']
  // if (userLogViews.indexOf(to.name) !== -1 && storeInstance.state.user.name === '') {
  //   let newRoute = { path: '/' + currentLang, params: { lang: currentLang } }
  //   next(newRoute)
  // }
  if (to.path === from.path && to.hash) {
    return { selector: to.hash }
  }
  if (to.fullPath !== redirectTo) {
    let newRoute = { path: redirectTo, params: { ...to.params, lang: currentLang } }
    next(newRoute)
    return
  }
  if (!from.name || currentLang !== lang) {
    store.dispatch('setLanguage', lang)
  }
  next()
})

export default router

